<template>
  <common-dialog ref="dialog" width="700px" title="修改SKU外部编码" :save-func="saveFunc" show-save-button @closed="onClosed"
    @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <el-table :data="skuList" border style="margin-bottom: 20px;" :max-height="500">
        <el-table-column prop="spec" label="SKU 名称" show-overflow-tooltip />
        <el-table-column label="SKU 外部编码" width="200px">
          <template slot-scope="{row}">
            <el-input v-model="row.sku.out_sku_sn" spellcheck="false" clearable />
          </template>
        </el-table-column>
      </el-table>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from '@/components/common/dialog';
import goodsApi from '@/api/pdd/goods';

export default {
  components: { commonDialog },
  data() {
    return {
      skuList: [],
      detail: null,
    }
  },
  methods: {
    openEdit(row) {
      this.detail = {
        goods_id: row.goodsId,
        goods_name: row.goodsName,
        carousel_gallery: row.carouselGalleryList,
        cat_id: row.catId,
        cost_template_id: row.costTemplateId,
        country_id: row.countryId,
        detail_gallery: row.detailGalleryList,
        out_goods_id: row.outerGoodsId,
        goods_type: row.goodsType,
        is_folt: row.isFolt,
        is_pre_sale: row.isPreSale,
        is_refundable: row.isRefundable,
        market_price: row.marketPrice,
        second_hand: row.secondHand == 1,
        shipment_limit_second: row.shipmentLimitSecond,
      };
      this.skuList = (row.skuList || []).map(x => ({
        spec: (x.spec || []).map(s => s.spec_name).join(''),
        sku: {
          is_onsale: x.is_onsale,
          limit_quantity: x.limit_quantity,
          multi_price: x.multi_price,
          out_sku_sn: x.out_sku_sn,
          price: x.price,
          quantity: 0,
          sku_id: x.sku_id,
          spec_id_list: `[${(x.spec || []).map(s => s.spec_id).join(",")}]`,
          thumb_url: x.thumb_url,
          weight: x.weight,
        },
      }));
      this.$refs.dialog.open();
    },
    saveFunc() {
      return new Promise((resolve, reject) => {
        if (!this.detail) { reject({ code: 1, msg: '保存失败' }); return; }
        var saveData = {
          dataList: [{
            ...this.detail,
            carousel_gallery: JSON.stringify(this.detail.carousel_gallery),
            detail_gallery: JSON.stringify(this.detail.detail_gallery),
            sku_list: JSON.stringify(this.skuList.map(x => x.sku)),
          }]
        };
        goodsApi.put(saveData).then(res => {
          if (res.data && res.data.length > 0) {
            var html = '';
            res.data.forEach(x => { html += '<div>' + x.errorMsg + '</div>' });
            this.$alert(html, '提示', { dangerouslyUseHTMLString: true, type: 'error' });
            reject({});
          } else {
            resolve({ Code: 0 });
          }
        }).catch(err => reject(err));
      });
    },
    onClosed() {

      this.skuList = [];
    },
  }
}
</script>
